<template>
  <div class="footer">
    <div class="copyright">
      <h2 style="color: rgba(255, 255, 255, 0.9);">天津易科芯科技有限公司</h2>
      <p style="border-bottom: 2px solid rgba(255, 255, 255, 0.1);">Tianjin Ekecore Technology Co.,Ltd. ，All Right Reserved.</p>
      <p>地址：天津市滨海新区中新天津生态城动漫中路126号动漫大厦B2-7层-108</p>
      <p>联系人：赵先生       电话 / 微信：15510917698 </p>
      <p>©2022 天津易科芯科技有限公司 版权所有    备案号: <a href="https://beian.miit.gov.cn/">津ICP备2022001692号-1</a></p>
    </div>

  </div>
</template>

<script>
export default { };
</script>

<style lang="less" scoped>

.footer { 
  width: 100%; margin: 10px auto;max-width: 1200px;color: #AAAAAA;
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
}
// .banner {  height: 60px;  }

.copyright { 
  width: 933px;line-height: 35px; 
  font-family: 'Lato', 'Helvetica Neue', Arial, Helvetica, sans-serif;
}


</style>
